export default __webpack_public_path__ + "static/media/pOPEN.5b1cfbe3.webp";